/* RESPONSIBLE TEAM: team-knowledge-foundations */

import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';
export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    folder: { key: 'folder_id' },
    folderMembership: { embedded: 'always' },
    tags: { key: 'tag_ids' },
    taggings: {
      serialize: 'records',
      deserialize: 'records',
    },
  },

  // The backend serves ecommerce products from the ecommerce_product_contents endpoint.
  // We remap the response payload key to our ecommerce-product model.
  modelNameFromPayloadKey() {
    return 'ecommerce-product';
  },

  payloadKeyFromModelName() {
    return 'ecommerce_product_content';
  },
});
